/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SexEnum } from './SexEnum';
import {
    SexEnumFromJSON,
    SexEnumFromJSONTyped,
    SexEnumToJSON,
} from './SexEnum';
import type { SpecialtiesEnum } from './SpecialtiesEnum';
import {
    SpecialtiesEnumFromJSON,
    SpecialtiesEnumFromJSONTyped,
    SpecialtiesEnumToJSON,
} from './SpecialtiesEnum';
import type { SubSpecialtiesEnum } from './SubSpecialtiesEnum';
import {
    SubSpecialtiesEnumFromJSON,
    SubSpecialtiesEnumFromJSONTyped,
    SubSpecialtiesEnumToJSON,
} from './SubSpecialtiesEnum';

/**
 * 
 * @export
 * @interface DoctorSignupStep3
 */
export interface DoctorSignupStep3 {
    /**
     *
     * @type {string}
     * @memberof DoctorSignupStep3
     */
    fullName?: string;
    /**
     * 
     * @type {SpecialtiesEnum}
     * @memberof DoctorSignupStep3
     */
    specialty?: SpecialtiesEnum;
    /**
     * 
     * @type {SubSpecialtiesEnum}
     * @memberof DoctorSignupStep3
     */
    subSpecialty?: SubSpecialtiesEnum;
    /**
     * 
     * @type {SexEnum}
     * @memberof DoctorSignupStep3
     */
    sex?: SexEnum;
}

/**
 * Check if a given object implements the DoctorSignupStep3 interface.
 */
export function instanceOfDoctorSignupStep3(value: object): boolean {
    return true;
}

export function DoctorSignupStep3FromJSON(json: any): DoctorSignupStep3 {
    return DoctorSignupStep3FromJSONTyped(json, false);
}

export function DoctorSignupStep3FromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorSignupStep3 {
    if (json == null) {
        return json;
    }
    return {

        'fullName': json['full_name'] == null ? undefined : json['full_name'],
        'specialty': json['specialty'] == null ? undefined : SpecialtiesEnumFromJSON(json['specialty']),
        'subSpecialty': json['sub_specialty'] == null ? undefined : SubSpecialtiesEnumFromJSON(json['sub_specialty']),
        'sex': json['sex'] == null ? undefined : SexEnumFromJSON(json['sex']),
    };
}

export function DoctorSignupStep3ToJSON(value?: DoctorSignupStep3 | null): any {
    if (value == null) {
        return value;
    }
    return {

        'full_name': value['fullName'],
        'specialty': SpecialtiesEnumToJSON(value['specialty']),
        'sub_specialty': SubSpecialtiesEnumToJSON(value['subSpecialty']),
        'sex': SexEnumToJSON(value['sex']),
    };
}

